export default __webpack_public_path__ + "static/media/hiGif.099abcba.gif";